<ul class="feedback-message-list" *ngIf="messages.length > 0">
    <li class="messages-timeline-item" *ngFor="let vmessage of messages | sortBy: 'date' : 'desc'">
        <core-message
            *ngIf="vmessage.message"
            [message]="vmessage.message"
            [feedback]="vmessage.feedback ? vmessage.feedback : null"
            [versionShares]="vmessage.version_shares ? vmessage.version_shares : null"
            [notesActionText]="canCreateNotes ? 'Add Notes' : 'See Notes'"
            [notesActionStyle]="canCreateNotes ? 'add-notes' : 'see-notes'"
            [canCreateNotes]="canCreateNotes"
            [prefixUrl]="prefixUrl"
            (onDelete)="onDelete.emit($event)"
        ></core-message>
        <core-message-feedback 
            *ngIf="!vmessage.message"
            [message]="vmessage"
        ></core-message-feedback>
    </li>
</ul>
